/* ==========================================================================
   Product Family Comparison
   Progressive enhancement for sections/product-family-comparison.liquid.
   1. Row hover: display:contents grid rows have no box of their own, so we
      mirror a hover class across all cells of a row (ported from the mockup).
   2. Mobile: highlight the scroll dot for the card currently in view.
   Works without JS; this only adds the hover wash and the active dot.
   ========================================================================== */
(function () {
  'use strict';

  class ProductFamilyComparison extends HTMLElement {
    connectedCallback() {
      this._wireRowHover();
      this._wireMobileDots();
      this._snapToFeatured();
    }

    /* Open the mobile carousel on the featured (this page's) card instead of
       the first sibling. Measures with getBoundingClientRect deltas relative
       to the scroller, so it is immune to offsetParent differences, and
       re-runs on resize (the mockup's earlier snap bug was both). */
    _snapToFeatured() {
      var scroller = this.querySelector('.pfc-mobile');
      if (!scroller) return;
      var snap = function () {
        if (scroller.offsetParent === null) return; // hidden at this width
        var featured = scroller.querySelector('.pfc-mobile__card--featured, .pfc-mobile__card.is-featured');
        if (!featured) return;
        var s = scroller.getBoundingClientRect();
        var f = featured.getBoundingClientRect();
        scroller.scrollLeft += (f.left - s.left) - (s.width - f.width) / 2;
      };
      window.requestAnimationFrame(snap);
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(snap, 150);
      }, { passive: true });
    }

    _wireRowHover() {
      this.querySelectorAll('[data-pfc-hover-row]').forEach(function (row) {
        var cells = Array.prototype.slice.call(row.children);
        cells.forEach(function (cell) {
          cell.addEventListener('mouseenter', function () {
            cells.forEach(function (c) { c.classList.add('pfc-row-hovered'); });
          });
          cell.addEventListener('mouseleave', function () {
            cells.forEach(function (c) { c.classList.remove('pfc-row-hovered'); });
          });
        });
      });
    }

    _wireMobileDots() {
      var scroller = this.querySelector('.pfc-mobile');
      var dots = this.querySelectorAll('.pfc-section__scroll-dot');
      if (!scroller || dots.length === 0) return;

      var ticking = false;
      var update = function () {
        var cards = scroller.querySelectorAll('.pfc-mobile__card');
        if (!cards.length) return;
        var cardWidth = cards[0].getBoundingClientRect().width + 16; // card + gap
        var index = Math.round(scroller.scrollLeft / cardWidth);
        if (index < 0) index = 0;
        if (index > dots.length - 1) index = dots.length - 1;
        dots.forEach(function (dot, i) {
          dot.classList.toggle('pfc-section__scroll-dot--active', i === index);
        });
      };

      scroller.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
    }
  }

  if (!customElements.get('product-family-comparison')) {
    customElements.define('product-family-comparison', ProductFamilyComparison);
  }
})();
